import { render } from "./EditWorkOrder.vue?vue&type=template&id=772a77da"
import script from "./EditWorkOrder.vue?vue&type=script&lang=js"
export * from "./EditWorkOrder.vue?vue&type=script&lang=js"
script.render = render

export default script